<template>
  <div class="visitorinfo">
    <h4 class="title">个人信息</h4>
    <el-form ref="form" :model="visitorinfo" label-width="60px">
      <el-form-item v-for="(item, index) in visitorinfo.display" :key="index" :label="item.fieldName">
        <el-select v-if="item.fieldName == '性别'" v-model="item.fieldValue" placeholder="未知" @change="changeHandler(item)">
          <el-option label="未知" value="0"></el-option>
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>
        </el-select>
        <el-input v-else-if="item.fieldName == '备注'" type="textarea" v-model="item.fieldValue" @change="changeHandler(item)"></el-input>
        <el-input v-else v-model="item.fieldValue" @change="changeHandler(item)"></el-input>
      </el-form-item>
      <!--<el-form-item label="姓名：">
        <el-input v-model="visitorinfo.name" @change="changeHandler('name', visitorinfo.name)"></el-input>
      </el-form-item>
      <el-form-item label="年龄：">
        <el-input v-model="visitorinfo.age" @change="changeHandler('age', visitorinfo.age)"></el-input>
      </el-form-item>
      <el-form-item label="性别：">
        <el-select v-model="visitorinfo.sex" placeholder="未知" @change="changeHandler('sex', visitorinfo.sex)">
          <el-option label="未知" value="0"></el-option>
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="电话：">
        <el-input v-model="visitorinfo.phone" @change="changeHandler('phone', visitorinfo.phone)"></el-input>
      </el-form-item>
      <el-form-item label="QQ：">
        <el-input v-model="visitorinfo.qq" @change="changeHandler('qq', visitorinfo.qq)"></el-input>
      </el-form-item>
      <el-form-item label="微信：">
        <el-input v-model="visitorinfo.wechat" @change="changeHandler('wechat', visitorinfo.wechat)"></el-input>
      </el-form-item>
      <el-form-item label="地址：">
        <el-input v-model="visitorinfo.address" @change="changeHandler('address', visitorinfo.address)"></el-input>
      </el-form-item>
      <el-form-item label="邮箱：">
        <el-input v-model="visitorinfo.email" @change="changeHandler('email', visitorinfo.email)"></el-input>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input type="textarea" v-model="visitorinfo.remark" @change="changeHandler('remark', visitorinfo.remark)"></el-input>
      </el-form-item>-->
    </el-form>
  </div>
</template>

<script>
  import { Message } from 'element-ui'

  export default {
    /**
     * @Author: xl
     * @NotedTime: 2018.8.18
     * @Email: xule@360shop.cn
     */
    props: ['visitorinfo', 'visitorId'],
    data () {
      return {
        /**
         * 【个人信息修改参数】
         * 访客id
         * 访客信息属性名称
         * 访客信息属性值
         */
        postData: {
          visitorId: '',
          name: '',
          value: ''
        }
      }
    },
    methods: {
      /**
       * 修改个人信息
       */
      changeHandler (item) {
        this.postData.visitorId = this.visitorId
        this.postData.name = item.fieldId
        this.postData.value = item.fieldValue
        this.editVisitorInfo()
      },
      editVisitorInfo () {
        this.$http.editVisitorInfo(this.postData)
        .then(res => {
          const resData = res
          if (resData.status == 1) {
			this.$emit('refreshVisitorInfo',this.visitorinfo)
            Message({
              showClose: true,
              message: resData.msg,
              type: 'success',
              duration: 3 * 1000
            })
          }
        }) 
      }
    }
  }
</script>

<style lang="scss">

  .visitorinfo {
    padding-top: 15px;
    .title {
      font-size: 12px;
      font-weight: bold;
    }
    .el-form {
      padding-top: 5px;
      &-item {
        margin: 0;
        &__label {
          font-size: 12px;
          line-height: 28px;
          padding: 0 5px 0 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &__content {
          font-size: 12px;
          line-height: 28px;
          .el-input {
            font-size: 12px;
            &__inner {
              height: 28px;
              line-height: 28px;
              padding: 0 8px;
              border-radius: 0;
            }
            &__icon {
              line-height: 28px;
            }
          }
          .el-select {
            width: 100%;
          }
          .el-textarea {
            font-size: 12px;
            &__inner {
              padding: 5px 8px;
              border-radius: 0;
              resize: none;
            }
          }
        }
        .el-input__inner, .el-textarea__inner {
          border-color: #fff;
          &:hover, &:focus{
            border-color: #dcdfe6;
          }
        }
      }
    }
  }
</style>
